module.exports = __webpack_public_path__ + "static/img/8000.6af358e6.png";